import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
	name: 'ui',
	initialState: {
		activeNotification: false,
		title: '',
		message: '',
		status: ''
	},
	reducers: {
		launchNotification(state, action) {
			state.title = action.payload.title;
			state.message = action.payload.message;
			state.status = action.payload.status;
			state.activeNotification = true;
		},
		dismissNotification(state) {
			state.activeNotification = false;
		}
	}
});

export const uiActions = uiSlice.actions;

export default uiSlice;
